import { FolderDto, UserProfileDto, UserRole } from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_FOLDERS } from "../domain";

import { foldersApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_FOLDER = "GET_FOLDER";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

export const getFolder = async (folderId?: string): Promise<FolderDto> => {
  const response = await foldersApi.foldersControllerGetFolder(folderId);

  return response.data;
};

export const useGetFolder = (
  user: UserProfileDto | null,
  folderId?: string,
): {
  folder: FolderDto | undefined;
  getFolderEnabled: boolean;
  getFolderError: Error | null;
  refetchGetFolder: () => void;
  isLoadingGetFolder: boolean;
  isFetchingGetFolder: boolean;
  isSuccessGetFolder: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryResult = useQuery<FolderDto, Error>({
    queryKey: [DOMAIN_FOLDERS, ACTION_GET_FOLDER, folderId],
    queryFn: () => getFolder(folderId),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    folder: queryResult.data,
    getFolderEnabled: enabled,
    getFolderError: queryResult.error,
    refetchGetFolder: queryResult.refetch,
    isLoadingGetFolder: queryResult.isLoading,
    isFetchingGetFolder: queryResult.isFetching,
    isSuccessGetFolder: queryResult.isSuccess,
  };
};
